// extracted by mini-css-extract-plugin
export default {"root":"_1jy6m","animator":"Eizzw","notification-link":"_3NVBA","notificationLink":"_3NVBA"};